import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {heroBasicSizes, heroBasicTitleSizes} from '@adv-mt/mt-hero-basic'

import {FORMALITIES_HERO_IMAGE, HERO_DESCRIPTION, HERO_TITLE} from './config.js'

export const useConfig = () => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const heroBasicHeaderProps = {
    title: {
      size: heroBasicTitleSizes.m,
      title: i18n.t(HERO_TITLE),
      description: i18n.t(HERO_DESCRIPTION)
    },
    size: heroBasicSizes.s,
    imageSrc: `${URL_STATICS_IMAGES}${FORMALITIES_HERO_IMAGE}`,
    withFullContrast: true
  }
  return {heroBasicHeaderProps}
}
